import { render, staticRenderFns } from "./aIMinutes.vue?vue&type=template&id=468559d0&scoped=true&"
import script from "./aIMinutes.vue?vue&type=script&lang=js&"
export * from "./aIMinutes.vue?vue&type=script&lang=js&"
import style0 from "./aIMinutes.vue?vue&type=style&index=0&id=468559d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468559d0",
  null
  
)

export default component.exports